import * as React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import withQueryParams, { InjectedQueryParams } from 'react-router-query-params'

import { RootState } from '../../store/rootReducer'
import { Pagination } from 'src/lib/interfaces/Pagination.interface'
import { CountByType } from 'src/lib/interfaces/CountByType.interface'
import { JobApplicant } from 'src/lib/interfaces/JobApplicant.interface'
import { applicationStatusToString } from 'src/lib/interfaces/ApplicationStatus.interface'
import { ApplicationFilterParameters } from 'src/lib/interfaces/ApplicationFilterParameters.interface'

import Moment from 'react-moment'
import { Table } from 'reactstrap'
import ReactPagination from 'react-js-pagination'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Breadcrumbs from '../Breadcrumbs.component'
import ApplicationFilter from './components/ApplicationFilter.component'
import ApplicationsSummary from './components/ApplicationsSummary.component'

import * as applicationsActions from '../../store/applications/actions'

import { formatName } from 'src/lib/helpers/format'
import { numberArrayDefaultValue } from 'src/utils/query-params'

const get = require('lodash/get')
const map = require('lodash/map')
const isEmpty = require('lodash/isEmpty')
const isEqual = require('lodash/isEqual')

export interface ApplicationsDashboardPageProps extends RouteComponentProps, InjectedQueryParams<ApplicationFilterParameters> {
  isFetchingSummary: boolean
  summaryData?: CountByType[]
  isFetchingApplications: boolean
  filterParams: ApplicationFilterParameters
  paginatedApplications?: Pagination<JobApplicant>
  setFilterParams: (filterParams: ApplicationFilterParameters) => void
}

class ApplicationsDashboardPage extends React.PureComponent<ApplicationsDashboardPageProps> {
  constructor(props: ApplicationsDashboardPageProps) {
    super(props)

    this.handlePageChange = this.handlePageChange.bind(this)
  }

  componentDidMount() {
    const { queryParams, setFilterParams } = this.props
    setFilterParams(queryParams)
  }

  componentDidUpdate(prevProps: ApplicationsDashboardPageProps) {
    const { filterParams, setQueryParams } = this.props
    const { filterParams: prevFilterParams } = prevProps

    if (!isEqual(filterParams, prevFilterParams)) {
      setQueryParams(filterParams)
    }
  }

  getClassNameForKey = (key: string): string | undefined => {
    const { filterParams } = this.props

    if (filterParams.sortBy !== key) { return }

    return `-sorted -${(filterParams.sortOrder || '').toLowerCase()}`
  }

  getApplicationLocationCode = (application: JobApplicant): string | undefined => {    
    const jobPosition = application!.jobPosition
    if (jobPosition) {
      return application!.jobPosition!.location.code
    }
    return 'N/A'
  }

  handleSortFilterChange = (sortBy: string): void => {
    const { filterParams } = this.props

    let sortOrder = filterParams.sortOrder
    if (!sortOrder || sortOrder === 'desc') { sortOrder = 'asc' }
    else if (sortOrder === 'asc') { sortOrder = 'desc' }

    this.onFiltersChange({
      ...filterParams,
      sortBy,
      sortOrder
    })
  }

  onFiltersChange = (filters: ApplicationFilterParameters) => {
    this.props.setFilterParams({
      ...filters,
      page: 0
    })
  }

  handlePageChange(page) {
    const { filterParams, setFilterParams } = this.props

    setFilterParams({
      ...filterParams,
      page
    })
  }

  render() {
    const { queryParams, isFetchingSummary, paginatedApplications, isFetchingApplications } = this.props
    
    return (
      <div className="d-flex flex-column min-height-100">
        <Breadcrumbs breadcrumbs={[
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Applications', active: true },
        ]} />

        <div className="page applications-page flex-grow-1 min-height-0">
          <section>
            <div className="d-flex align-items-center mb-2">
              <h5 className="title mb-0">Application Stats</h5>
              {isFetchingSummary && <FontAwesomeIcon spin size="lg" className="ml-3" icon={['fas', 'spinner']} />}
            </div>

            <ApplicationsSummary />
          </section>

          {/* <section className="mt-5">
            <h5 className="title">Action Items</h5>

            <div className="row no-gutters mt-3">
              <div className="col-3 pr-3">
                <div className="ggcard">
                  <div className="card-body">
                    <div className="w-100 d-flex justify-content-between">
                      <div className="card-subtitle">Application reviews</div>
                      <span className="card-subtitle">10</span>
                    </div>
                    <div className="mt-1">Review new employee applications for your location.</div>
                  </div>
                </div>

                <div className="ggcard ggcard--dark mt-3 p-3">
                  <div className="ggcard ggcard--actionable">
                    <div className="card-body p-3">
                      <div className="card-subtitle">Caio Rodrigues</div>
                      <div className="mt-1">Queued 1 day</div>
                    </div>
                  </div>

                  <div className="ggcard ggcard--actionable mt-3">
                    <div className="card-body p-3">
                      <div className="card-subtitle">Ravel Antunes</div>
                      <div className="d-flex align-items-center mt-1">
                        Queued 10 day
                        <FontAwesomeIcon
                          color="red"
                          className="ml-2"
                          style={{ fontSize: '16px' }}
                          icon={['fas', 'exclamation-circle']}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="ggcard ggcard--actionable mt-3">
                    <div className="card-body p-3">
                      <div className="card-subtitle">John Doe</div>
                      <div className="d-flex align-items-center mt-1">
                        Queued 10 day
                        <FontAwesomeIcon
                          color="red"
                          className="ml-2"
                          style={{ fontSize: '16px' }}
                          icon={['fas', 'exclamation-circle']}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-3 pr-3">
                <div className="ggcard">
                  <div className="card-body">
                    <div className="w-100 d-flex justify-content-between">
                      <div className="card-subtitle">Onsite interviews</div>
                      <span className="card-subtitle">2</span>
                    </div>
                    <div className="mt-1">Complete interviews that have been scheduled for your location.</div>
                  </div>
                </div>

                <div className="ggcard ggcard--dark mt-3 p-3">
                  <div className="ggcard ggcard--actionable">
                    <div className="card-body p-3">
                      <div className="card-subtitle">Caio Rodrigues</div>
                      <div className="mt-1">Queued 1 day</div>
                    </div>
                  </div>

                  <div className="ggcard ggcard--actionable mt-3">
                    <div className="card-body p-3">
                      <div className="card-subtitle">Ravel Antunes</div>
                      <div className="d-flex align-items-center mt-1">
                        Queued 10 day
                        <FontAwesomeIcon
                          color="red"
                          className="ml-2"
                          style={{ fontSize: '16px' }}
                          icon={['fas', 'exclamation-circle']}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}

          <section className="mt-5">
            <div className="d-flex align-items-center mb-3">
              <h5 className="title mb-0">Pending Applications</h5>
              {isFetchingApplications && <FontAwesomeIcon spin size="lg" className="ml-3" icon={['fas', 'spinner']} />}
            </div>

            <ApplicationFilter
              filterParams={queryParams}
              onChange={this.onFiltersChange}
            />

            <Table hover className="ggtable">
              <thead>
                <tr>
                  <th
                    style={{ width: '40%' }}
                    onClick={() => this.handleSortFilterChange('firstName')}
                    className={classnames('-sortable', this.getClassNameForKey('firstName'))}
                  >
                    Applicant name
                  </th>
                  <th style={{ width: '20%' }}>Location</th>
                  <th
                    style={{ width: '20%' }}
                    onClick={() => this.handleSortFilterChange('dateCreated')}
                    className={classnames('-sortable', this.getClassNameForKey('dateCreated'))}
                  >
                    Date applied
                  </th>
                  <th style={{ width: '20%' }}>Hire phase</th>
                </tr>
              </thead>
              
              <tbody>
                {paginatedApplications && map(paginatedApplications.content, application => (
                  <tr key={application.id} onClick={() => this.props.history.push(`/applications/${application.id}`)}>
                    <td>{formatName(application)}</td>
                    <td>
                      <div className="badge badge-primary">
                        {this.getApplicationLocationCode(application)}
                      </div>
                    </td>
                    <td><Moment date={application.dateCreated} format="MM.DD.YYYY" /></td>
                    <td>{application.status ? applicationStatusToString(application.status) : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </section>

          {paginatedApplications && (
            <div className="d-flex justify-content-end">
              <ReactPagination
                itemClass="page-item"
                linkClass="page-link"
                activePage={paginatedApplications.number + 1}
                itemsCountPerPage={paginatedApplications.size}
                onChange={page => this.handlePageChange(page - 1)}
                totalItemsCount={paginatedApplications.totalElements}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  summaryData: state.applications.summaryData,
  filterParams: state.applications.filterParams,
  isFetchingSummary: state.applications.isFetchingSummary,
  paginatedApplications: state.applications.paginatedApplications,
  isFetchingApplications: state.applications.isFetchingApplications
})

const mapDispatchToProps = (dispatch) => ({
  setFilterParams: (filterParams: ApplicationFilterParameters) =>
    dispatch(applicationsActions.setApplicationsFilterParams(filterParams))
})

export default 
  connect(mapStateToProps, mapDispatchToProps)(
    withQueryParams<ApplicationFilterParameters, ApplicationsDashboardPageProps>({
      stripUnknownKeys: true,
      keys: {
        page: {
          validate: value => false,
          default: (value, props) => {
            if (value) {
              // return parseInt(value, 10)
              return value
            }

            return props.filterParams.page
          }
        },
        search: {
          validate: value => !isEmpty(value)
        },
        location: {
          validate: () => false,
          default: (value, props) => {
            if (value) {
              return numberArrayDefaultValue(value)
            }
  
            return props.filterParams.location
          }
        },
        status: {
          validate: () => false,
          default: (value, props) => {
            if (value) { return value }
            return props.filterParams.status
          }
        },
        sortBy: {
          validate: () => false,
          default: (value, props) => {
            if (value) { return value }
            return props.filterParams.sortBy
          }
        },
        sortOrder: {
          validate: () => false,
          default: (value, props) => {
            if (value) { return value }
            return props.filterParams.sortOrder
          }
        }
      }
    }
)(withRouter(ApplicationsDashboardPage)))



// WEBPACK FOOTER //
// ./src/routes/applications/ApplicationsDashboard.page.tsx